module.exports = __webpack_public_path__ + "static/media/isabella.837a4b35.png";